import { createStore, select, withProps } from '@ngneat/elf';
import {
  getAllEntities,
  selectAllEntities,
  setEntities,
  withEntities,
} from '@ngneat/elf-entities';
import {
  map,
  withLatestFrom,
  filter,
  startWith,
  shareReplay,
} from 'rxjs/operators';
import { RoomModel } from '../model';

const store = createStore(
  { name: 'room' },
  withEntities<RoomModel, 'roomId'>({ idKey: 'roomId' }),
  withProps<{ loading: boolean }>({ loading: false })
);

const rooms$ = store.pipe(selectAllEntities());

const roomIsLoading$ = store.pipe(
  select((state) => state.loading),
  startWith(false)
);

const roomLoaded$ = rooms$.pipe(
  withLatestFrom(roomIsLoading$),
  filter(([rooms, loading]) => rooms.length > 0 && loading),
  map(([rooms]) => rooms),
  shareReplay({ bufferSize: 1, refCount: true })
);

const hasRooms = () => store.query(getAllEntities()).length > 0;

const setLoading = (loading: boolean) =>
  store.update((state) => ({ ...state, loading }));

const setRooms = (rooms: RoomModel[]) => store.update(setEntities(rooms));

const getRooms = () => store.query(getAllEntities());

export const RoomRepository = {
  store,
  setRooms,
  setLoading,
  roomLoaded$,
  roomIsLoading$,
  hasRooms,
  rooms$,
  getRooms,
};
